// extracted by mini-css-extract-plugin
export default {"sideicon":"SideIcons_sideicon__e8Zd7","mobicon":"SideIcons_mobicon__yiSog","SocialIcon":"SideIcons_SocialIcon__BwnVl","line":"SideIcons_line__BE9GL"};